<script setup>
import PublicLayout from '@/Layouts/PublicLayout.vue';

// Add blocks here
import Banner from '@/Components/Blocks/Banner.vue';
import Blog from '@/Components/Blocks/Blog.vue';
import ContactForm from '@/Components/Blocks/ContactForm.vue';
import Counter from '@/Components/Blocks/Counter/Counters.vue';
import Faq from '@/Components/Blocks/Faq/Faq.vue';
import FixedCta from '@/Components/Blocks/FixedCta.vue';
import Gallery from '@/Components/Blocks/Gallery.vue';
import GoogleMaps from '@/Components/Blocks/GoogleMaps.vue';
import Image from '@/Components/Blocks/Image.vue';
import JobApplicationForm from '@/Components/Blocks/JobApplicationForm.vue';
import LogoSlider from '@/Components/Blocks/LogoSlider.vue';
import News from '@/Components/Blocks/News/News.vue';
import Newsletter from '@/Components/Blocks/Newsletter.vue';
import Package from '@/Components/Blocks/Package/Package.vue';
import PageHeader from '@/Components/Blocks/PageHeader.vue';
import Projects from '@/Components/Blocks/Project/Projects.vue';
import ReviewSlider from '@/Components/Blocks/ReviewSlider.vue';
import Services from '@/Components/Blocks/Service/Services.vue';
import Team from '@/Components/Blocks/Team.vue';
import Text from '@/Components/Blocks/Text.vue';
import Vacancies from '@/Components/Blocks/Vacancy/Vacancies.vue';
import Youtube from '@/Components/Blocks/Youtube.vue';

const props = defineProps({
    page: Object,
});
</script>

<template>
    <PublicLayout :title="page.page_title" :description="page.page_description">
        <template v-for="(content, i) in page.page_contents" :key="i">
            <Banner v-if="content.type == 'App-Filament-Blocks-Banner'" v-bind="content.data" />
            <Text v-if="content.type == 'App-Filament-Blocks-Text'" v-bind="content.data" />
            <Gallery v-if="content.type == 'App-Filament-Blocks-Gallery'" v-bind="content.data" />
            <Youtube v-if="content.type == 'App-Filament-Blocks-YouTube'" v-bind="content.data" />
            <LogoSlider v-if="content.type == 'App-Filament-Blocks-LogoSlider'" v-bind="content.data" />
            <Package v-if="content.type == 'App-Filament-Blocks-Packages'" v-bind="content.data" />
            <Newsletter v-if="content.type == 'App-Filament-Blocks-Newsletter'" v-bind="content.data" />
            <ReviewSlider v-if="content.type == 'App-Filament-Blocks-ReviewSlider'" v-bind="content.data" />
            <Projects v-if="content.type == 'App-Filament-Blocks-Projects'" v-bind="content.data" />

            <PageHeader v-if="content.type == 'App-Filament-Blocks-PageHeader'" v-bind="content.data" :page="page" />
            <Image v-if="content.type == 'App-Filament-Blocks-Image'" v-bind="content.data" />
            <Vacancies v-if="content.type == 'App-Filament-Blocks-Vacancies'" v-bind="content.data" />
            <ContactForm v-if="content.type == 'App-Filament-Blocks-ContactForm'" v-bind="content.data" />
            <JobApplicationForm v-if="content.type == 'App-Filament-Blocks-JobApplicationForm'" v-bind="content.data" />
            <Faq v-if="content.type == 'App-Filament-Blocks-Faq'" v-bind="content.data" />
            <Counter v-if="content.type == 'App-Filament-Blocks-counter'" v-bind="content.data" />
            <Team v-if="content.type == 'App-Filament-Blocks-Team'" v-bind="content.data" />
            <Blog v-if="content.type == 'App-Filament-Blocks-Blog'" v-bind="content.data" />
            <News v-if="content.type == 'App-Filament-Blocks-News'" v-bind="content.data" />
            <GoogleMaps v-if="content.type == 'App-Filament-Blocks-GoogleMaps'" v-bind="content.data" />
            <Services v-if="content.type == 'App-Filament-Blocks-Services'" v-bind="content.data" />
            <FixedCta v-if="content.type == 'App-Filament-Blocks-FixedCta'" v-bind="content.data" />
            <!-- Add blocks here -->
        </template>
    </PublicLayout>
</template>
